import React, { useEffect, useState } from "react";
import { Landmark, Music2, CalendarDays } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HistoryFacts = () => {
  const [facts, setFacts] = useState({ general: null, music: null });

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/history-facts`);
        if (!res.ok) return;
        const data = await res.json();
        if (active && data) setFacts({ general: data.general, music: data.music });
      } catch (e) {
        /* ignore */
      }
    };
    load();
    const id = setInterval(load, 60 * 60 * 1000);
    return () => { active = false; clearInterval(id); };
  }, []);

  if (!facts.general && !facts.music) return null;

  return (
    <section className="pt-2 pb-10" data-testid="history-facts">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="mb-5 flex items-center gap-2">
          <CalendarDays className="h-4 w-4 text-white/80" />
          <span className="text-sm font-bold uppercase tracking-widest text-white/80">
            Vandaag in de geschiedenis
          </span>
        </div>

        <div className="relative overflow-hidden rounded-3xl bg-[#4288F5] border border-white/15 p-6 sm:p-8 shadow-[0_18px_40px_-22px_rgba(8,30,80,0.5)]">
          <div className="grid gap-6 md:grid-cols-2 md:gap-0">
            {/* Dutch general history */}
            <div className="md:pr-8" data-testid="fact-general">
              <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/70">
                <Landmark className="h-4 w-4" /> Nederlandse geschiedenis
              </span>
              <p className="mt-3 font-heading text-base sm:text-lg font-semibold leading-relaxed text-white">
                {facts.general || "\u2014"}
              </p>
            </div>

            {/* Transparent divider */}
            <div className="pointer-events-none absolute inset-x-6 top-1/2 hidden h-px -translate-y-1/2 bg-white/20 md:left-1/2 md:right-auto md:top-8 md:bottom-8 md:h-auto md:w-px md:translate-y-0" />
            <div className="h-px w-full bg-white/15 md:hidden" />

            {/* Dutch music history */}
            <div className="md:pl-8" data-testid="fact-music">
              <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/70">
                <Music2 className="h-4 w-4" /> Muziekgeschiedenis
              </span>
              <p className="mt-3 font-heading text-base sm:text-lg font-semibold leading-relaxed text-white">
                {facts.music || "\u2014"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HistoryFacts;
